<template>
  <div class="add-box">
    <el-button type="text" :disabled="loading" @click="loadDetail">
      <slot></slot>
    </el-button>

    <el-drawer
        title="开票信息"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeHandle"
    >
      <el-row>
        <el-col :span="20" :offset="2">
          <h3>申请信息</h3>
          <el-descriptions :column="3" border>
            <el-descriptions-item label="申请企业">{{ detail.organize_name }}</el-descriptions-item>
            <el-descriptions-item label="申请人">{{ detail.admin_name }}元</el-descriptions-item>
            <el-descriptions-item label="发票类型">{{ detail.type_desc }}</el-descriptions-item>
            <el-descriptions-item label="抬头名称">{{ detail.name }}天</el-descriptions-item>
            <el-descriptions-item label="税号">{{ detail.tax_no }}</el-descriptions-item>
            <el-descriptions-item label="开票金额">{{ detail.amount }}</el-descriptions-item>
            <el-descriptions-item label="申请时间">{{ detail.create_at }}</el-descriptions-item>
            <el-descriptions-item label="开票状态">
              <el-tag v-if="detail.status === 1">{{ detail.status_desc }}</el-tag>
              <el-tag v-if="detail.status === 2" type="success">{{ detail.status_desc }}</el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </el-col>
        <el-col :span="20" :offset="2" v-if="detail.status === 2">
          <h3>发票信息</h3>
          <el-table :data="list" border style="width: 100%">
            <el-table-column label="发票文件">
              <template slot-scope="scope">
                <a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" :disabled="delIng" @click="toDelete(scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="20" :offset="2">
          <h3>发票上传</h3>
          <el-upload
              ref="uploadBtn"
              drag
              action=""
              name="file"
              :data="{}"
              :auto-upload="false"
              :limit="9"
              :headers="{}"
              @submit="toSubmit"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传pdf,png,jpeg,jpg格式的发票文件</div>
          </el-upload>
          <el-button type="primary" @click="toSubmit">提交</el-button>
        </el-col>
      </el-row>
    </el-drawer>

  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      user: {},
      loading: false,
      query: {
        id: '',
      },
      detail: {},
      list: [],
      openStatus: false,
      delIng: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    param: {
      type: Object,
      default: () => {
        return {
          id: ''
        };
      }
    }
  },
  mounted() {
  },
  methods: {
    loadDetail() {
      const _this = this;
      _this.loading = true;
      _this.detail = {}
      _this.query.id = _this.param.id;
      _this.$apiAdmin.adminInvoiceUpdateDetail(_this.query)
          .then(res => {
            _this.openStatus = true;
            _this.loading = false;
            _this.detail = res.detail;
            _this.list = res.list;
          })
          .catch(err => {
            _this.loading = false;
            _this.openStatus = false;
          })
    },
    closeHandle() {
      const _this = this;
      _this.openStatus = false;
      _this.detail = {}
      _this.$emit('finish', {})
    },
    toSubmit() {
      const _this = this;
      if (_this.$refs.uploadBtn.uploadFiles.length > 0) {
        const files = _this.$refs.uploadBtn.uploadFiles;
        const formData = new FormData();
        formData.append('id', _this.query.id)
        files.forEach((item, i) => {
          formData.append('file[]', item.raw)
        })
        _this.submitIng = false;
        _this.$apiAdmin.adminInvoiceUpdate(formData)
            .then(res => {
              _this.submitIng = false;
              _this.$message.success('上传成功');
              _this.$refs.uploadBtn.clearFiles();
              _this.loadDetail();
            })
            .catch(err => {
              _this.submitIng = false;
              _this.$message.error(err.msg);
            })
      } else {
        _this.$message.error('上传文件不能为空');
      }
    },
    toDelete(item) {
      const _this = this;
      _this.delIng = false;
      _this.$apiAdmin.adminInvoiceDelete({id: item.id})
          .then(res => {
            _this.delIng = false;
            _this.$message.success('删除成功');
            _this.loadDetail();
          })
          .catch(err => {
            _this.delIng = false;
            _this.$message.error(err.msg);
          })
    }
  }
}
</script>

<style scoped>
.add-box {
  padding-right: 10px;
}
</style>